var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#E4EEFB",
    width: 60,
    height: 60,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.556 13.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.012 0c8.844 0 16.013 7.169 16.013 16.012 0 8.844-7.17 16.013-16.013 16.013H0V16.012C0 7.17 7.169 0 16.012 0zm4.493 10.461a1 1 0 0 0-1.38-.313l-5.991 3.773-1.737 6.864a1 1 0 0 0 1.502 1.092l5.992-3.773 1.737-6.865a1 1 0 0 0-.123-.778z",
    fill: "#3979FF"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2FCBFF",
    cx: 29.737,
    cy: 23.85,
    r: 9.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.737 14.7c.778 0 1.534.097 2.255.28.022.342.033.686.033 1.032 0 6.24-3.57 11.646-8.777 14.288a9.15 9.15 0 0 1 6.49-15.6z",
    fill: "#0A41F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcount);
export default __webpack_public_path__ + "static/media/acount.26d5e211bb302bfbd283aff3a9956a8e.svg";
export { ForwardRef as ReactComponent };